import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 20000 });

export const api = {
    listCategories: (sort = "count") =>
        client.get("/categories", { params: { sort } }).then((r) => r.data),
    getCategory: (slug) =>
        client.get(`/categories/${slug}`).then((r) => r.data),
    getCategoryProducts: (slug, params = {}) =>
        client
            .get(`/categories/${slug}/products`, { params })
            .then((r) => r.data),
    getRecent: (limit = 8) =>
        client
            .get("/products/recent", { params: { limit } })
            .then((r) => r.data),
    getProduct: (slug) => client.get(`/products/${slug}`).then((r) => r.data),
    listProducts: (q, limit = 50) =>
        client.get("/products", { params: { q, limit } }).then((r) => r.data),
    upvoteProduct: (slug) =>
        client.post(`/products/${slug}/upvote`).then((r) => r.data),
    submit: (payload) =>
        client.post("/submissions", payload).then((r) => r.data),
    search: (q) => client.get("/search", { params: { q } }).then((r) => r.data),
    getStats: () => client.get("/stats").then((r) => r.data),
    getOpportunities: () =>
        client.get("/opportunities").then((r) => r.data),
    joinWaitlist: (payload) =>
        client.post("/waitlist", payload).then((r) => r.data),
};
